import { AppError } from '@/utils/api';
import { normalizeCheckoutUrlEnv } from '@/utils/checkoutUrl';
import { AuthenticatedHttp } from '../../http/axios';

function normalizeOfferCurrency(offer) {
  if (!offer || typeof offer !== 'object') return offer;
  return {
    ...offer,
    currency: offer.currency ?? offer.currency_code ?? offer.currencyCode,
  };
}

/** Normaliza currency no link e na oferta. */
export function normalizeProductLinkResult(result) {
  if (!result || typeof result !== 'object') return result;
  const url = result.type === 'checkout' ? normalizeCheckoutUrlEnv(result.url) : result.url;

  return {
    ...result,
    url,
    currency: result.currency ?? result.currency_code ?? result.currencyCode,
    offer: normalizeOfferCurrency(result.offer),
  };
}

export const getProductLinksService = async ({
  product,
  search = '',
  status = 'all',
  page = 1,
  limit = 10,
  short_user_id = '',
}) => {
  const url = short_user_id ? 'affiliate_links' : 'links';
  return AuthenticatedHttp.get(`/${product}/${url}/`, {
    params: {
      search,
      status,
      page,
      limit,
    },
  })
    .then(({ data: { count, next, previous, results, ...rest } }) => {
      const formatResults = results.map((result) => {
        const normalized = normalizeProductLinkResult(result);
        return {
          ...normalized,
          url: short_user_id ? `${normalized.url}?affiliate=${short_user_id}` : normalized.url,
          shortUrl: short_user_id
            ? `${process.env.REACT_APP_SHORT_URL.replace(/\/+$/, '')}/${
                normalized.shortId
              }/?affiliate=${short_user_id}`
            : normalized.shortUrl,
        };
      });
      return { count, next, previous, results: formatResults, ...rest };
    })
    .catch((error) => {
      throw new AppError(error);
    });
};

export const createProductLinkService = async ({ product, name, url }) =>
  AuthenticatedHttp.post(`/${product}/links/`, { name, url })
    .then((response) => response.data)
    .catch((error) => {
      throw new AppError(error);
    });

export const updateProductLinkService = async ({ id, name, url }) =>
  AuthenticatedHttp.put(`/link/${id}/`, { name, url })
    .then((response) => response.data)
    .catch((error) => {
      throw new AppError(error);
    });

export const showProductLinkToAffiliatesService = async ({ id }) =>
  AuthenticatedHttp.post(`/link/${id}/show_affiliates/`)
    .then((response) => response.data)
    .catch((error) => {
      throw new AppError(error);
    });

export const hideProductLinkToAffiliatesService = async ({ id }) =>
  AuthenticatedHttp.post(`/link/${id}/hide_affiliates/`)
    .then((response) => response.data)
    .catch((error) => {
      throw new AppError(error);
    });

export const enableProductLinksService = async ({ ids }) =>
  AuthenticatedHttp.post(`/link/enable_many/`, { ids })
    .then((response) => response.data)
    .catch((error) => {
      throw new AppError(error);
    });

export const disableProductLinksService = async ({ ids }) =>
  AuthenticatedHttp.post(`/link/disable_many/`, { ids })
    .then((response) => response.data)
    .catch((error) => {
      throw new AppError(error);
    });

export const changeProductLinkStatusService = async ({ ids, status }) =>
  new Promise((resolve) =>
    setTimeout(
      () =>
        resolve({
          success: true,
        }),
      1000
    )
  ).catch((error) => {
    throw new AppError(error);
  });

export const deleteProductLinkService = async ({ id }) =>
  AuthenticatedHttp.delete(`/link/${id}/`)
    .then((response) => response.data)
    .catch((error) => {
      throw new AppError(error);
    });
